import { DocumentType, WorkflowResultData, FileObject, WorkflowDataDisplay } from "./Workflow"
import { TypeColors } from "../components/atoms/AcTag"

export type ContractDocument = {
  id: number
  userId: number
  workflowId: number
  workflowName: string
  workflowPosition: number
  contractId: number
  documentGroup: DocumentGroup
  documentType: DocumentType
  docWorkflowNo: DocWorkflowNos
  workflowData: WorkflowResultData[]
  state: string
  nextEvents: string[]
  stateMetadata: StateMetadata
  tags: string[]
  version: number
  ledgerFlg?: number
  workflows: any // TODO HungHV: fix trc 17/9/2024
}

export type DocumentWorkFlowDisplayResponse = {
  workFlowData: WorkflowDataDisplay[]
  currentPosition: number
  workflowName: string
}

export type ContractDocumentDetail = ContractDocument & {
  notRequireUpload: boolean
}

export type DocumentGroup = {
  value: keyof typeof DocumentGroupTypes
  text: DocumentGroupTypes
}

export type StateMetadata = {
  text: string
  color: keyof typeof TypeColors
  screen: DockWorkflowScreen
  disableCheckbox?: boolean
  canViewDetail: boolean
  canActivateButton: boolean
}

export enum DockWorkflowScreen {
  ADD_IMPORTANT_DOCUMENT_SCREEN = "ADD_IMPORTANT_DOCUMENT_SCREEN",
  ADD_CONTRACT_DOCUMENT_SCREEN = "ADD_CONTRACT_DOCUMENT_SCREEN",
  UPLOAD_SCREEN = "UPLOAD_SCREEN",
  RECEIVE_SCREEN = "RECEIVE_SCREEN",
  SIGN_SCREEN = "SIGN_SCREEN",
  REQUEST_APPROVAL_SCREEN = "REQUEST_APPROVAL_SCREEN",
  APPROVAL_SCREEN = "APPROVAL_SCREEN",
  SEND_SCREEN = "SEND_SCREEN",
  VIDEO_CALL_SCREEN = "VIDEO_CALL_SCREEN",
  REQUIRED_CHECK_DIALOG = "REQUIRED_CHECK_DIALOG",
}

export enum DocWorkflowNos {
  DOC_WORKFLOW_01 = "DOC_WORKFLOW_01",
  DOC_WORKFLOW_02 = "DOC_WORKFLOW_02",
  DOC_WORKFLOW_03 = "DOC_WORKFLOW_03",
  DOC_WORKFLOW_04 = "DOC_WORKFLOW_04",
  DOC_WORKFLOW_05 = "DOC_WORKFLOW_05",
  DOC_WORKFLOW_06 = "DOC_WORKFLOW_06",
  DOC_WORKFLOW_07 = "DOC_WORKFLOW_07",
  DOC_WORKFLOW_08 = "DOC_WORKFLOW_08",
  DOC_WORKFLOW_09 = "DOC_WORKFLOW_09",
  DOC_WORKFLOW_10 = "DOC_WORKFLOW_10",
  DOC_WORKFLOW_11 = "DOC_WORKFLOW_11",
  DOC_WORKFLOW_12 = "DOC_WORKFLOW_12",
  DOC_WORKFLOW_13 = "DOC_WORKFLOW_13",
  DOC_WORKFLOW_14 = "DOC_WORKFLOW_14",
  DOC_WORKFLOW_15 = "DOC_WORKFLOW_15",
  DOC_WORKFLOW_16 = "DOC_WORKFLOW_16",
  DOC_WORKFLOW_17 = "DOC_WORKFLOW_17",
  DOC_WORKFLOW_18 = "DOC_WORKFLOW_18",
  DOC_WORKFLOW_19 = "DOC_WORKFLOW_19",
  DOC_WORKFLOW_20 = "DOC_WORKFLOW_20",
  DOC_WORKFLOW_99 = "DOC_WORKFLOW_99",
}

export enum DocumentGroupTypes {
  IT_IMPORTANT_DOCUMENTS = "IT重説関連書類",
  OTHER_DOCUMENTS = "その他契約関連書類",
  CUSTOMER_ISSUED_DOCUMENTS = "お客様交付書類",
  BROKERAGE_COMPANY_ISSUED_DOCUMENTS = "仲介会社様宛書類",
  MANAGEMENT_COMPANY_REGISTRATION_DOCUMENTS = "管理会社登録書類",
  REQUIRED_DOCUMENT = "提出書類",
}

export enum GenericActionTypes {
  UPLOAD = "UPLOAD",
  SEND = "SEND",
  REQUEST_APPROVAL = "REQUEST_APPROVAL",
  APPROVE = "APPROVE",
  REJECT = "REJECT",
  SIGN = "SIGN",
  RECEIVE = "RECEIVE",
  CANCEL = "CANCEL",
}

export enum DocWorkflow01EventType {
  ManagerUploadDocument = "ManagerUploadDocument",
  ManagerRequestApproval = "ManagerRequestApproval",
  ManagerSendDocumentToAgent = "ManagerSendDocumentToAgent",
  ManagerApproveRequest = "ManagerApproveRequest",
  ManagerRejectRequest = "ManagerRejectRequest",
  AgentConfirmReceivedDocument = "AgentConfirmReceivedDocument",
  AgentVerifySignedDocument = "AgentVerifySignedDocument",
  AgentRequestApproval = "AgentRequestApproval",
  AgentSendDocumentToContractor = "AgentSendDocumentToContractor",
  AgentApproveRequest = "AgentApproveRequest",
  AgentRejectRequest = "AgentRejectRequest",
  ContractorSignDocument = "ContractorSignDocument",
  ContractorSignDocumentOnMeeting = "ContractorSignDocumentOnMeeting",
  ManagerConfirmReceivedDocument = "ManagerConfirmReceivedDocument",
}

export enum DocWorkflow02EventType {
  ManagerUploadDocument = "ManagerUploadDocument",
  ManagerRequestApproval = "ManagerRequestApproval",
  ManagerSendDocumentToAgent = "ManagerSendDocumentToAgent",
  ManagerApproveRequest = "ManagerApproveRequest",
  ManagerRejectRequest = "ManagerRejectRequest",
  AgentConfirmReceivedDocument = "AgentConfirmReceivedDocument",
  AgentVerifySignedDocument = "AgentVerifySignedDocument",
  AgentRequestApproval = "AgentRequestApproval",
  AgentApproveRequest = "AgentApproveRequest",
  AgentRejectRequest = "AgentRejectRequest",
  ManagerConfirmReceivedDocument = "ManagerConfirmReceivedDocument",
}

export enum DocWorkflow03EventType {
  ManagerUploadDocument = "ManagerUploadDocument",
  ManagerRequestApproval = "ManagerRequestApproval",
  ManagerSendDocumentToAgent = "ManagerSendDocumentToAgent",
  ManagerApproveRequest = "ManagerApproveRequest",
  ManagerRejectRequest = "ManagerRejectRequest",
  AgentConfirmReceivedDocument = "AgentConfirmReceivedDocument",
  AgentSendDocumentToContractor = "AgentSendDocumentToContractor",
  ContractorSignDocument = "ContractorSignDocument",
  ManagerConfirmReceivedDocument = "ManagerConfirmReceivedDocument",
}

export enum DocWorkflow04EventType {
  ManagerUploadDocument = "ManagerUploadDocument",
  ManagerRequestApproval = "ManagerRequestApproval",
  ManagerSendDocumentToAgent = "ManagerSendDocumentToAgent",
  ManagerApproveRequest = "ManagerApproveRequest",
  ManagerRejectRequest = "ManagerRejectRequest",
  AgentConfirmReceivedDocument = "AgentConfirmReceivedDocument",
  AgentVerifySignedDocument = "AgentVerifySignedDocument",
  AgentRequestApproval = "AgentRequestApproval",
  AgentSendDocumentToContractor = "AgentSendDocumentToContractor",
  AgentApproveRequest = "AgentApproveRequest",
  AgentRejectRequest = "AgentRejectRequest",
  ManagerConfirmReceivedDocument = "ManagerConfirmReceivedDocument",
  ContractorConfirmReceivedDocument = "ContractorConfirmReceivedDocument",
}

export enum DocWorkflow05EventType {
  AgentUploadDocument = "AgentUploadDocument",
  AgentSendDocumentToContractor = "AgentSendDocumentToContractor",
  ContractorConfirmReceivedDocument = "ContractorConfirmReceivedDocument",
}

export enum DocWorkflow06EventType {
  ManagerUploadMultiDocument = "ManagerUploadMultiDocument",
  ManagerRequestApproval = "ManagerRequestApproval",
  ManagerSendDocumentToAgent = "ManagerSendDocumentToAgent",
  ManagerApproveRequest = "ManagerApproveRequest",
  ManagerRejectRequest = "ManagerRejectRequest",
  AgentConfirmReceivedDocument = "AgentConfirmReceivedDocument",
}

export enum DocWorkflow07EventType {
  ManagerUploadDocument = "ManagerUploadDocument",
}

export enum DocWorkflow08EventType {
  ManagerUploadDocument = "ManagerUploadDocument",
  ManagerSendDocumentToAgent = "ManagerSendDocumentToAgent",
  ManagerRequestApproval = "ManagerRequestApproval",
  ManagerApproveRequest = "ManagerApproveRequest",
  ManagerRejectRequest = "ManagerRejectRequest",
  AgentConfirmReceivedDocument = "AgentConfirmReceivedDocument",
  AgentVerifySignedDocument = "AgentVerifySignedDocument",
  AgentRequestApproval = "AgentRequestApproval",
  AgentApproveRequest = "AgentApproveRequest",
  AgentRejectRequest = "AgentRejectRequest",
  AgentSendDocumentToContractor = "AgentSendDocumentToContractor",
  ContractorSignDocument = "ContractorSignDocument",
  Guarantee01SignDocument = "Guarantee01SignDocument",
  Guarantee02SignDocument = "Guarantee02SignDocument",
  ManagerConfirmReceivedDocument = "ManagerConfirmReceivedDocument",
}

export enum DocWorkflow09EventType {
  ManagerUploadDocument = "ManagerUploadDocument",
  ManagerSendDocumentToAgent = "ManagerSendDocumentToAgent",
  ManagerRequestApproval = "ManagerRequestApproval",
  ManagerApproveRequest = "ManagerApproveRequest",
  ManagerRejectRequest = "ManagerRejectRequest",
  AgentConfirmReceivedDocument = "AgentConfirmReceivedDocument",
  AgentSendDocumentToContractor = "AgentSendDocumentToContractor",
  ContractorSignDocument = "ContractorSignDocument",
  Guarantee01SignDocument = "Guarantee01SignDocument",
  Guarantee02SignDocument = "Guarantee02SignDocument",
  ManagerConfirmReceivedDocument = "ManagerConfirmReceivedDocument",
}

export enum DocWorkflow10EventType {
  ContractorSendDocumentToResident = "ContractorSendDocumentToResident",
  ManagerUploadDocument = "ManagerUploadDocument",
  ManagerSendDocumentToAgent = "ManagerSendDocumentToAgent",
  AgentSendDocumentToContractor = "AgentSendDocumentToContractor",
  AgentConfirmReceivedDocument = "AgentConfirmReceivedDocument",
  ManagerConfirmReceivedDocument = "ManagerConfirmReceivedDocument",
  ManagerRejectRequest = "ManagerRejectRequest",
  ContractorSignDocument = "ContractorSignDocument",
  ContractorCancelSignByResident = "ContractorCancelSignByResident",
}

export enum DocWorkflow11EventType {
  ManagerUploadDocument = "ManagerUploadDocument",
  ManagerRequestApproval = "ManagerRequestApproval",
  ManagerSendDocumentToAgent = "ManagerSendDocumentToAgent",
  ManagerApproveRequest = "ManagerApproveRequest",
  ManagerRejectRequest = "ManagerRejectRequest",
  AgentConfirmReceivedDocument = "AgentConfirmReceivedDocument",
  AgentVerifySignedDocument = "AgentVerifySignedDocument",
  AgentRequestApproval = "AgentRequestApproval",
  AgentSendDocumentToContractor = "AgentSendDocumentToContractor",
  AgentApproveRequest = "AgentApproveRequest",
  AgentRejectRequest = "AgentRejectRequest",
  ContractorSignDocument = "ContractorSignDocument",
  OwnerAgencyConfirmReceivedDocument = "OwnerAgencyConfirmReceivedDocument",
  ManagerConfirmReceivedDocument = "ManagerConfirmReceivedDocument",
}

export enum DocWorkflow12EventType {
  ManagerUploadDocument = "ManagerUploadDocument",
  ManagerSendDocumentToAgent = "ManagerSendDocumentToAgent",
  ManagerRequestApproval = "ManagerRequestApproval",
  ManagerApproveRequest = "ManagerApproveRequest",
  ManagerRejectRequest = "ManagerRejectRequest",
  AgentConfirmReceivedDocument = "AgentConfirmReceivedDocument",
  AgentVerifySignedDocument = "AgentVerifySignedDocument",
  AgentRequestApproval = "AgentRequestApproval",
  AgentApproveRequest = "AgentApproveRequest",
  AgentRejectRequest = "AgentRejectRequest",
  AgentSendDocumentToContractor = "AgentSendDocumentToContractor",
  ContractorSignDocument = "ContractorSignDocument",
  OwnerAgencySignDocument = "OwnerAgencySignDocument",
  CollectionAgencySignDocument = "CollectionAgencySignDocument",
  ContractorSendDocumentToOwner = "ContractorSendDocumentToOwner",
  OwnerSignDocument = "OwnerSignDocument",
  ManagerConfirmReceivedDocument = "ManagerConfirmReceivedDocument",
  CancelOwnerSign = "CancelOwnerSign",
}

export enum DocWorkflow15EventType {
  ManagerUploadDocument = "ManagerUploadDocument",
  ManagerSendDocumentToAgent = "ManagerSendDocumentToAgent",
  ManagerRequestApproval = "ManagerRequestApproval",
  ManagerApproveRequest = "ManagerApproveRequest",
  ManagerRejectRequest = "ManagerRejectRequest",
  AgentConfirmReceivedDocument = "AgentConfirmReceivedDocument",
  AgentVerifySignedDocument = "AgentVerifySignedDocument",
  AgentRequestApproval = "AgentRequestApproval",
  AgentApproveRequest = "AgentApproveRequest",
  AgentRejectRequest = "AgentRejectRequest",
  AgentSendDocumentToContractor = "AgentSendDocumentToContractor",
  ContractorSignDocument = "ContractorSignDocument",
  Guarantee01SignDocument = "Guarantee01SignDocument",
  Guarantee02SignDocument = "Guarantee02SignDocument",
  OwnerAgencySignDocument = "OwnerAgencySignDocument",
  CollectionAgencySignDocument = "CollectionAgencySignDocument",
  OwnerSignDocument = "OwnerSignDocument",
  ManagerConfirmReceivedDocument = "ManagerConfirmReceivedDocument",
  CancelOwnerSign = "CancelOwnerSign",
}

export enum DocWorkflow13EventType {
  ManagerUploadDocument = "ManagerUploadDocument",
  ManagerSendDocumentToAgent = "ManagerSendDocumentToAgent",
  AgentSendDocumentToContractor = "AgentSendDocumentToContractor",
  AgentConfirmReceivedDocument = "AgentConfirmReceivedDocument",
  ManagerConfirmReceivedDocument = "ManagerConfirmReceivedDocument",
  ManagerApproveRequest = "ManagerApproveRequest",
  ManagerRejectRequest = "ManagerRejectRequest",
  ContractorSignDocument = "ContractorSignDocument",
  OwnerAgencyConfirmReceivedDocument = "OwnerAgencyConfirmReceivedDocument",
}

export enum DocWorkflow14EventType {
  ManagerUploadDocument = "ManagerUploadDocument",
  ManagerSendDocumentToAgent = "ManagerSendDocumentToAgent",
  ManagerRequestApproval = "ManagerRequestApproval",
  ManagerApproveRequest = "ManagerApproveRequest",
  ManagerRejectRequest = "ManagerRejectRequest",
  AgentConfirmReceivedDocument = "AgentConfirmReceivedDocument",
  AgentSendDocumentToContractor = "AgentSendDocumentToContractor",
  ContractorConfirmReceivedDocument = "ContractorConfirmReceivedDocument",
  OwnerAgencyConfirmReceivedDocument = "OwnerAgencyConfirmReceivedDocument",
}

export enum DocWorkflow16EventType {
  ManagerUploadDocument = "ManagerUploadDocument",
  ManagerSendDocumentToAgent = "ManagerSendDocumentToAgent",
  ManagerRequestApproval = "ManagerRequestApproval",
  ManagerApproveRequest = "ManagerApproveRequest",
  ManagerRejectRequest = "ManagerRejectRequest",
  AgentConfirmReceivedDocument = "AgentConfirmReceivedDocument",
  AgentSendDocumentToContractor = "AgentSendDocumentToContractor",
  ContractorSignDocument = "ContractorSignDocument",
  Guarantee01SignDocument = "Guarantee01SignDocument",
  Guarantee02SignDocument = "Guarantee02SignDocument",
  OwnerAgencyConfirmReceivedDocument = "OwnerAgencyConfirmReceivedDocument",
  ManagerConfirmReceivedDocument = "ManagerConfirmReceivedDocument",
}
export enum DocWorkflow18EventType {
  ManagerUploadDocument = "ManagerUploadDocument",
  ManagerSendDocumentToAgent = "ManagerSendDocumentToAgent",
  ManagerRequestApproval = "ManagerRequestApproval",
  ManagerApproveRequest = "ManagerApproveRequest",
  ManagerRejectRequest = "ManagerRejectRequest",
  AgentConfirmReceivedDocument = "AgentConfirmReceivedDocument",
  AgentVerifySignedDocument = "AgentVerifySignedDocument",
  AgentRequestApproval = "AgentRequestApproval",
  AgentApproveRequest = "AgentApproveRequest",
  AgentRejectRequest = "AgentRejectRequest",
  OwnerAgencyConfirmReceivedDocument = "OwnerAgencyConfirmReceivedDocument",
  ManagerConfirmReceivedDocument = "ManagerConfirmReceivedDocument",
}
export enum DocWorkflow19EventType {
  ResetManagerApprovalFlow = "ResetManagerApprovalFlow",
  ResetAgentApprovalFlow = "ResetAgentApprovalFlow",
  ManagerUploadDocument = "ManagerUploadDocument",
  ManagerRequestApproval = "ManagerRequestApproval",
  ManagerSendDocumentToContractor = "ManagerSendDocumentToContractor",
  ManagerApproveRequest = "ManagerApproveRequest",
  ManagerRejectRequest = "ManagerRejectRequest",
  ContractorReceiveDocument = "ContractorReceiveDocument",
  Guarantee01ReceiveDocument = "Guarantee01ReceiveDocument",
  Guarantee02ReceiveDocument = "Guarantee02ReceiveDocument",
}

export enum DocWorkflow20EventType {
  AgentUploadMultiDocument = "AgentUploadMultiDocument",
  AgentSendDocumentToManager = "AgentSendDocumentToManager",
  ManagerConfirmReceivedDocument = "ManagerConfirmReceivedDocument",
}

export enum DocWorkflow99EventType {
  ManagerConfirmReceivedDocument = "ManagerConfirmReceivedDocument",
}

export enum StateTags {
  LOADING = "LOADING",
  CAN_SEND = "CAN_SEND",
  NOT_UPLOADED = "NOT_UPLOADED",
  CONTRACTOR_SIGNED = "CONTRACTOR_SIGNED",
  ALLOW_SENDING_IT_IMPORTANT_DOCUMENTS = "ALLOW_SENDING_IT_IMPORTANT_DOCUMENTS",
  APPROVAL_REQUIRED_CHECK = "APPROVAL_REQUIRED_CHECK",
  UNDER_APPROVING_BY_MANAGER = "UNDER_APPROVING_BY_MANAGER",
  UNDER_APPROVING_BY_AGENT = "UNDER_APPROVING_BY_AGENT",
  BEFORE_SENDING_IT_IMPORTANT_DOCUMENTS_REQUIRED_CHECK = "BEFORE_SENDING_IT_IMPORTANT_DOCUMENTS_REQUIRED_CHECK",
  CAN_VIDEO_CALL = "CAN_VIDEO_CALL",
  CANNOT_DELETE = "CANNOT_DELETE",
  SENT_TO_CONTRACTOR = "SENT_TO_CONTRACTOR",
  SENT_TO_GUARANTEE = "SENT_TO_GUARANTEE",
  CAN_REUPLOAD = "CAN_REUPLOAD",
  GUARANTEE_01_SIGNED = "GUARANTEE_01_SIGNED",
  GUARANTEE_02_SIGNED = "GUARANTEE_02_SIGNED",
  CUSTOMER_SIGNED = "CUSTOMER_SIGNED",
}

export enum WorkflowName {
  USAGE_DETAILS = "使用細則",
  PERSONAL_INFO_CONSENT_FORM = "個人情報同意書",
  TOKYO_RULES = "東京ルール",
  ROOM_UNSEEN = "未内覧承諾書",
  INVOICE = "請求書",
  IMPORTANT = "重要事項説明書",
  CONTRACT = "賃貸借契約書",
}
